
import { Pencil } from 'lucide-react';

type ConfirmEditDialogProps = {
  onConferma: () => void;
  onAnnulla: () => void;
};

export const ConfirmEditDialog = ({ onConferma, onAnnulla }: ConfirmEditDialogProps) => {
    return (
      <div className="text-center">
        <div className="flex justify-center mb-3">
          <div className="w-11 h-11 rounded-full bg-[#1B365D]/10 flex items-center justify-center">
            <Pencil className="w-5 h-5 text-[#1B365D]" />
          </div>
        </div>
        <h2 className="text-base font-semibold mb-4 text-center">Sei sicuro di voler modificare?</h2>
        <div className="flex justify-center gap-9 mt-9">
          <button
            onClick={onAnnulla}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-medium text-gray-500 hover:border-red-300 hover:text-red-500 transition-all"
          >
            Annulla
          </button>
          <button
            onClick={onConferma}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#1B365D] text-xs font-medium text-white hover:bg-[#1B365D]/90 transition-all"
          >
            Procedi
          </button>
        </div>
      </div>
    );
  };